let unsaved = false;

export const setUnsaved = (v) => { unsaved = v; };

export const confirmLeave = () =>
  !unsaved || window.confirm("You have an unsaved purchase or expense. Leave this page and lose it?");
